import { styled } from '@mui/material';

export const StyledInputs = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    '.MuiTextField-root': { maxWidth: '100%' },
  },
}));

export const InfoStyledInputs = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '48%' },
  },
  [theme.breakpoints.up('md')]: {
    '.MuiTextField-root, .file-field': { maxWidth: '49%' },
  },
  '.file-field .MuiTextField-root': { maxWidth: '100%' },
}));
